






import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import { neoPvcProcessUrl } from '@/api/environment';

@Component({})
export default class extends Vue {
  public processUrl = neoPvcProcessUrl;
}
